/* eslint-disable radix */
/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
// import moment from "moment";
import styles from "../Components/ExportButton/ExportButton.styles";
import Button from "../../../components/common/Button/index";
// import Reports from "../../../../services/api/reports";
import Toast from "../../../components/common/Toast";

function ExportButton({ data, exportFunction }) {
  const [showToast, setShowToast] = useState(null);
  // const [id, setId] = useState(null);
  // const [fullName, setFullName] = useState(null);
  const location = useLocation();
  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const Id = queryParams.get("id");
  //   setId(Id);
  //   const FullName = queryParams.get("fullName");
  //   setFullName(FullName);
  // }, [location.search]);
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);
    try {
      // const dateFromQueryParam = queryParams.get("dateFrom");
      // const dateToQueryParam = queryParams.get("dateTo");
      // const formattedDateFrom = moment(
      //   dateFromQueryParam,
      //   "DD-MMM-YYYY"
      // ).format("YYYY-MM-DD");
      // const formattedDateTo = moment(dateToQueryParam, "DD-MMM-YYYY").format(
      //   "YYYY-MM-DD"
      // );
      const divisionIdQueryParam = queryParams.get("divisionIds");
      const divisionIds = divisionIdQueryParam
        ? divisionIdQueryParam
            .split(",")
            .map((id) => parseInt(id, 10))
            .filter(Boolean)
        : [];
      const payload = {
        areaId: queryParams.get("areaId"),
        clusterId: queryParams.get("clusterId") || null,
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        divisionIds,
        subDivisionId: queryParams.get("subDivisionId") || null,
        meetingType: queryParams.get("meetingType") || null,
        // dateFrom: formattedDateFrom || null,
        // dateTo: formattedDateTo || null,
        dateFrom: queryParams.get("dateFrom") || null,
        dateTo: queryParams.get("dateTo") || null,
      };

      // const response = await Reports.downloadMembersReport({
      //   data: payload,
      // });
      const response = await exportFunction({
        data: payload,
      });
      const { name } = response.data;
      if (response.code === 200) {
        setShowToast({
          message: `${name} will be available shortly under downloads`,
          severity: "success",
        });
      }
    } catch (error) {
      setShowToast({
        message: error,
        severity: "error",
      });
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box style={styles.dropdownBtn}>
        {" "}
        <Button
          variant="outlined"
          style={styles.leftSideBtn}
          onClick={handleExport}
          label="Download Reports"
          startIcon={
            <SaveAltIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
        <Box sx={styles.arrowIcon}>
          <ArrowDropDownIcon />
        </Box>
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default ExportButton;
